import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import TopBar from "../__shared__/TopBar";
import ProfileMenu from "../__shared__/ProfileMenu";
import StepMarkerBar from "../__shared__/StepMarkerBar";
import PreviousStepButton from "../__shared__/PreviousStepButton";
import NextStepButton from "../__shared__/NextStepButton";
import {
    EDIT_MARGIN_STEP,
    FREEHAND_SUMMARY_STEP,
    SEG_MRI_STEP,
    SUMMARY_STEP,
} from "../CreateTPlan_1Upload/constants";
import {
    resetCreatePlanShard,
    setCurrentTreatmentPlan,
    setStepActive,
    setStepComplete,
} from "../CreateTPlan_1Upload/actions";
import "./styles.css";
import cubeBlue from "../../assets/nav_cube_blue.svg";
import cubeDark from "../../assets/nav_cube_dark.svg";
import cubeLight from "../../assets/nav_cube_light.svg";
import ButtonGroup from "../__shared__/ButtonGroup";
import MeshViewer from "../__shared__/Viewers/MeshViewer";
import SummaryPanel from "./SummaryPanel";
import SliceControl from "../__shared__/SliceControl";
import {
    addPendoTracking,
    getLoadingScreen,
    hasProperty,
    isEmpty,
} from "../../helpers/helpers";
import {
    packPlan,
    releasePlanLock,
    updateTreatmentPlan,
} from "../../helpers/backend_api";
import MRIControlBar from "../__shared__/MRIControlBar";
import { resetImageViewerShard } from "../../redux/image_viewer/actions";
import {
    clientErrorMessages,
    EMPTY_STRING,
    loginReducerFlags,
    pageLoadStates,
    stepPath,
    SUCCESS,
} from "../../constants";
import MRIViewerButton from "../__shared__/MRIViewerButton";
import NavCubeModal from "../__shared__/NavCubeModal";
import RequirementsModal from "../__shared__/RequirementsModal";
import DecisionAlertCard from "../__shared__/DecisionAlertCard";
import { resetCreatePlanBiopsyShard } from "../CreateTPlan_3Biopsy/actions";
import filterBlue from "../../assets/filter_blue.svg";
import filterDark from "../../assets/filter_dark.svg";
import filterLight from "../../assets/filter_light.svg";
import FilterToggle from "../__shared__/FilterToggle";
import PropTypes from "prop-types";
import { setFlag } from "../Login/actions";
import DownloadSelectCard from "../__shared__/DownloadSelectCard";
import { setDownloadProperties } from "../Home/actions";
import MRIModel from "../__shared__/Viewers/Structures/MRI/MRIModel";
import MRIController from "../__shared__/Viewers/Structures/MRI/MRIController";
import {
    loadBxCores,
    loadMargin,
    loadMri,
    loadProstate,
    loadROIs,
    resetViewer,
} from "../../helpers/load_helpers";
import PatientAnatomyModel from "../__shared__/Viewers/Structures/PatientAnatomy/PatientAnatomyModel";
import { setDebugHooks } from "../../helpers/debug/debug_hooks";
import * as TreatmentPlan from "../../helpers/tplan/tplan";
import MRIViewer from "../__shared__/Viewers/MRIViewer";
import SplitPane from "react-split-pane";
import PatientAnatomyController from "../__shared__/Viewers/Structures/PatientAnatomy/PatientAnatomyController";
import SpinLoader from "../__shared__/SpinLoader";
import ResetViewerButton from "../__shared__/ResetViewerButton";
import { RESET_VIEW } from "../CreateTPlan_2SegMRI/constants";
import { getCemWarningMsg } from "../CreateTPlan_4CancerLesion/helpers";
import CaseExportIcon from "../../ui/icons/CaseExportIcon";
import { rootStore } from "../../redux/store";
import { setErrorState } from "../../redux/error_banner/actions";
import { trackingEventNames } from "../../helpers/pendo_constants";
import { getNotifications } from "../Home/helpers";
import {
    getNotificationList,
    isFirstTimePlanApproved,
} from "../__shared__/ChangeNotificationModal/helpers";
import {
    changeNotificationDescription,
    notificationListStage,
} from "./constants";
import ChangeNotificationModal from "../__shared__/ChangeNotificationModal";
import { getModalConfig } from "./helpers";
import UnfoldLogo from "../../ui/logos/UnfoldLogo";

// TODO: Change the wording "Finalize Plan" to "Approve Plan" in the code
class CreateTPlan_5Summary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // Set the correct initial value for planFinalized to prevent the top right button
            // from re-rendering and displaying different values before the page is fully loaded.
            planFinalized:
                props.currentTreatmentPlan?.SavedData?.PlanCreationCompleteFlag,
            displayDownloadAlert: false,
            loadState: pageLoadStates.LOADING,
            finalizeInProgress: false,
            cemWarningMsg: EMPTY_STRING,
            autoLevel: false,
            notifications: [],
            displayNotificationList: false,
            displayApprovePopup: false,
            notificationListStage: EMPTY_STRING,
        };

        this.requirements = {
            required: [
                {
                    id: "confirm-plan-req",
                    satisfied: false,
                    reqText: "Finalize and Confirm Case",
                    listIndex: 1,
                },
            ],
            optionals: [],
        };

        this.mriRef = React.createRef();
        this.meshRef = React.createRef();
        this.sliceControlRef = React.createRef();

        this.mriModel = new MRIModel(true);
        this.mriController = new MRIController(this.mriModel);
        this.patientAnatomyModel = new PatientAnatomyModel();
        this.patientAnatomyController = new PatientAnatomyController(
            this.patientAnatomyModel
        );

        setDebugHooks({
            mriModel: this.mriModel,
            patientAnatomyModel: this.patientAnatomyModel,
        });

        this.prevStep = this.prevStep.bind(this);
        this.finalizePlan = this.finalizePlan.bind(this);
        this.getDownloadModal = this.getDownloadModal.bind(this);
        this.handleFinalizeOrReopenPlanClick =
            this.handleFinalizeOrReopenPlanClick.bind(this);
    }

    componentDidMount() {
        try {
            const plan = this.props.currentTreatmentPlan;
            this.getCemWarnings(plan);
            this.getMRIURLs(plan);
            this.getMeshURLs(plan);
            this.setState({
                planFinalized: plan.SavedData?.PlanCreationCompleteFlag,
            });
        } catch {
            addPendoTracking(
                trackingEventNames.SUMMARY_PAGE_LOAD,
                this.props.planuuid,
                "Summary page failed to load."
            );
            this.setState({ loadState: pageLoadStates.FAILED });
        }
    }

    prevStep() {
        let plan = this.props.currentTreatmentPlan;

        if (TreatmentPlan.isMRIOnly(this.props.currentTreatmentPlan)) {
            this.props.setStepActive(FREEHAND_SUMMARY_STEP, false);
            this.props.setStepComplete(FREEHAND_SUMMARY_STEP, false);
            this.props.setStepActive(SEG_MRI_STEP, true);
            plan.SavedData.PlanCreationStep = SEG_MRI_STEP;
        } else {
            this.props.setStepActive(SUMMARY_STEP, false);
            this.props.setStepComplete(SUMMARY_STEP, false);
            this.props.setStepActive(EDIT_MARGIN_STEP, true);
            plan.SavedData.PlanCreationStep = EDIT_MARGIN_STEP;
        }

        this.props.setCurrentTreatmentPlan(plan);
        updateTreatmentPlan({
            useruuid: this.props.useruuid,
            patientuuid: this.props.patientuuid,
            planuuid: this.props.planuuid,
            token: this.props.authToken,
            plan: plan,
        });
    }

    async getChangeNotifications() {
        const payload = await getNotifications({
            planuuid: this.props.planuuid,
            token: this.props.authToken,
        });

        if (payload && payload.status === SUCCESS) {
            return payload.changeNotificationList;
        }
        return [];
    }

    getCemWarnings(plan) {
        if (!plan.SavedData.CEMWarnings) {
            return;
        }

        let cemWarnings = plan.SavedData.CEMWarnings;

        let warningString = getCemWarningMsg(cemWarnings);

        this.setState({
            cemWarningMsg: warningString,
        });
    }

    getMeshURLs(plan) {
        const ids = {
            token: this.props.authToken,
            useruuid: this.props.useruuid,
            patientuuid: this.props.patientuuid,
            planuuid: this.props.planuuid,
            visituuid: this.props.visituuid,
        };

        loadBxCores({
            ids,
            plan,
            patientAnatomyModel: this.patientAnatomyModel,
        });
        loadProstate({
            plan,
            ids,
            patientAnatomyModel: this.patientAnatomyModel,
            createBoundingCone: false,
            createAxes: true,
            setLoadState: (newState) => this.setState({ loadState: newState }),
        });
        loadROIs({
            plan,
            ids,
            patientAnatomyModel: this.patientAnatomyModel,
            patientAnatomyController: this.patientAnatomyController,
        });
        loadMargin({
            plan,
            ids,
            patientAnatomyModel: this.patientAnatomyModel,
            setLoadState: (newState) => this.setState({ loadState: newState }),
        });
    }

    getMRIURLs(plan) {
        const ids = {
            token: this.props.authToken,
            useruuid: this.props.useruuid,
            patientuuid: this.props.patientuuid,
            planuuid: this.props.planuuid,
            visituuid: this.props.visituuid,
        };

        loadMri({
            ids,
            currentTreatmentPlan: plan,
            mriModel: this.mriModel,
            loadState: this.state.loadState,
            setLoadState: (newState) => this.setState({ loadState: newState }),
        }).then(() => {
            this.setState({ autoLevel: this.mriModel.initializeAutoLevel() });
        });
    }

    requirementsCheck() {
        return this.state.planFinalized;
    }

    getRequirements() {
        this.requirements.required[0].satisfied = this.state.planFinalized;
        return this.requirements;
    }

    async finalizePlan() {
        this.setState({
            finalizeInProgress: true,
        });

        await releasePlanLock({
            token: this.props.authToken,
            useruuid: this.props.useruuid,
            planuuid: this.props.planuuid,
        });

        let scope = this;

        this.setState({
            planFinalized: true,
            displayDownloadAlert: true,
        });

        let plan = this.props.currentTreatmentPlan;

        if (!hasProperty(plan, "SavedData.PlanCreationCompleteFlag")) {
            return;
        }

        plan.SavedData.PlanCreationCompleteFlag = true;
        plan.SavedData.PlanCreationStep = SUMMARY_STEP;

        this.props.setFlag({
            flagId: loginReducerFlags.PLAN_COMPLETED,
            newFlagState: true,
        });

        await updateTreatmentPlan({
            useruuid: this.props.useruuid,
            patientuuid: this.props.patientuuid,
            planuuid: this.props.planuuid,
            token: this.props.authToken,
            plan: plan,
        })
            .then((response) => response.json())
            .then((json) => {
                if (json.message === SUCCESS) {
                    scope.props.setCurrentTreatmentPlan(json.payload.plan);
                    scope.props.setStepComplete(SUMMARY_STEP, true);
                }
            });

        packPlan({
            useruuid: this.props.useruuid,
            patientuuid: this.props.patientuuid,
            planuuid: this.props.planuuid,
            token: this.props.authToken,
        });

        this.setState({
            finalizeInProgress: false,
        });
    }

    getDownloadModal() {
        const isPlanFinalized =
            this.props.currentTreatmentPlan?.SavedData
                ?.PlanCreationCompleteFlag;

        const pdfOnly = isPlanFinalized === false || isPlanFinalized === null;

        this.setState({ displayDownloadAlert: false });
        this.props.setDownloadProperties(
            true,
            this.props.patientuuid,
            this.props.planuuid,
            pdfOnly
        );
    }

    async handleFinalizeOrReopenPlanClick() {
        const pdfOnly = false;
        const openDownloadModal = false;
        const notifications = await this.getChangeNotifications();

        this.setState({
            notifications: notifications,
        });

        if (this.getPlanCreationCompleteFlag(this.props.currentTreatmentPlan)) {
            this.props.setDownloadProperties(
                openDownloadModal,
                this.props.patientuuid,
                this.props.planuuid,
                pdfOnly
            );
            await this.savePlanCreationCompleteFlag(false);

            this.setState({
                planFinalized: false,
                displayNotificationList: true,
                notificationListStage: notificationListStage.REOPEN,
            });

            // This flag loginReducerFlags.PLAN_COMPLETED is checked by the Router.
            // If it still stays true, it will not allow users to go back to previous step
            // and instead force users to go to Home page.
            this.props.setFlag({
                flagId: loginReducerFlags.PLAN_COMPLETED,
                newFlagState: false,
            });
        } else {
            if (isFirstTimePlanApproved(this.state.notifications)) {
                // Change notification is not displayed if the plan is approved for the first time.
                this.setState({
                    displayApprovePopup: true,
                });
            } else {
                this.setState({
                    displayNotificationList: true,
                    notificationListStage:
                        notificationListStage.APPROVE_CONFIRMATION,
                });
            }
        }
    }

    async savePlanCreationCompleteFlag(flagValue) {
        const plan = this.props.currentTreatmentPlan;

        if (plan?.SavedData?.PlanCreationCompleteFlag) {
            plan.SavedData.PlanCreationCompleteFlag = flagValue;
        }

        updateTreatmentPlan({
            useruuid: this.props.useruuid,
            patientuuid: this.props.patientuuid,
            planuuid: this.props.planuuid,
            token: this.props.authToken,
            plan: plan,
        })
            .then((payload) => payload.json())
            .then((json) => {
                this.props.setCurrentTreatmentPlan(json.payload.plan);
            })
            .catch(() => {
                rootStore.dispatch(
                    setErrorState(true, clientErrorMessages.TPLAN_UPDATE_FAILED)
                );
            });
    }

    isPdfOnly() {
        const isPlanFinalized =
            this.props.currentTreatmentPlan?.SavedData
                ?.PlanCreationCompleteFlag;
        return isPlanFinalized === false || isPlanFinalized === null;
    }

    getApprovePopup() {
        if (this.state.displayApprovePopup) {
            return (
                <DecisionAlertCard
                    id={"summary-alert"}
                    noBtnCallback={() => {
                        this.setState({ displayApprovePopup: false });
                    }}
                    noBtnTxt={"Go Back"}
                    yesBtnTxt={
                        this.state.finalizeInProgress ? (
                            <SpinLoader
                                display={"inline-block"}
                                height={"25px"}
                                width={"25px"}
                                animationDuration={"1s"}
                            />
                        ) : (
                            "Approve Case"
                        )
                    }
                    yesBtnCallback={() => {
                        this.setState({
                            displayApprovePopup: false,
                        });
                        this.finalizePlan();
                    }}
                >
                    <div className={"summary-alert-card-header"}>
                        <p className="text-xl">Approve Case</p>
                    </div>
                    <div className={"summary-alert-card-body"}>
                        <div className={"summary-alert-row"}>
                            <p>
                                {
                                    changeNotificationDescription.APPROVE_CONFIRMATION
                                }
                            </p>
                        </div>
                    </div>
                </DecisionAlertCard>
            );
        }
    }

    showDownloadCard() {
        if (this.props.downloadProperties.selectActive) {
            return (
                <DownloadSelectCard
                    currentTreatmentPlan={this.props.currentTreatmentPlan}
                    pdfOnly={this.isPdfOnly()}
                />
            );
        }
    }

    getPreviousStep(plan) {
        return TreatmentPlan.isMRIOnly(plan) ? stepPath.STEP2 : stepPath.STEP4;
    }

    getPlanCreationCompleteFlag(plan) {
        let flag = false;
        if (
            !isEmpty(plan) &&
            hasProperty(plan, "SavedData.PlanCreationCompleteFlag")
        ) {
            flag = plan.SavedData.PlanCreationCompleteFlag;
        }
        return flag;
    }

    hideNotificationModal = () => {
        this.setState({ displayNotificationList: false });
    };

    handleApproveConfirmation = () => {
        this.finalizePlan();
        this.hideNotificationModal();
    };

    showChangeNotificationModal() {
        if (!this.state.displayNotificationList) {
            return null;
        }

        const modalConfig = getModalConfig(this.state.notificationListStage);
        if (!modalConfig) {
            return null;
        }

        const proceedBtnCallback =
            this.state.notificationListStage ===
            notificationListStage.APPROVE_CONFIRMATION
                ? this.handleApproveConfirmation
                : this.hideNotificationModal;

        return (
            <ChangeNotificationModal
                {...modalConfig}
                notifications={getNotificationList(this.state.notifications)}
                toggleOffChangeNotificationCallback={this.hideNotificationModal}
                proceedBtnCallback={proceedBtnCallback}
            />
        );
    }

    render() {
        let previousStep = this.getPreviousStep(
            this.props.currentTreatmentPlan
        );

        let previousButtonStyle = this.state.planFinalized
            ? { visibility: "hidden" }
            : {};

        return (
            <div className={"create-plan-summary-screen"}>
                <TopBar>
                    <Link to={stepPath.HOME}>
                        <UnfoldLogo />
                    </Link>
                    <div className={"create-plan-step-bar-container"}>
                        <div className="step-bar-prev-btn-group">
                            <PreviousStepButton
                                to={previousStep}
                                callback={this.prevStep}
                                style={previousButtonStyle}
                                isReady={
                                    this.state.loadState !==
                                    pageLoadStates.LOADING
                                }
                            />
                            <StepMarkerBar
                                previousStepsDisabled={this.state.planFinalized}
                            />
                        </div>
                        <NextStepButton
                            reqsComplete={this.requirementsCheck()}
                            reqsCompleteTxt="Edit Case"
                            reqsIncompleteTxt="Approve Case"
                            noLink={true}
                            callback={this.handleFinalizeOrReopenPlanClick}
                            isFreehandPlan={TreatmentPlan.isMRIOnly(
                                this.props.currentTreatmentPlan
                            )}
                            cemWarningMsg={this.state.cemWarningMsg}
                        />
                    </div>
                    <div
                        id="download-pdf-button"
                        className="w-[52px] cursor-pointer pt-2"
                        onClick={this.getDownloadModal}
                    >
                        <CaseExportIcon />
                    </div>
                    <ProfileMenu />
                </TopBar>
                <RequirementsModal
                    onRef={(ref) => (this.requirementsModalRef = ref)}
                    requirements={this.getRequirements()}
                />
                <SummaryPanel
                    isFreehandPlan={TreatmentPlan.isMRIOnly(
                        this.props.currentTreatmentPlan
                    )}
                    cemWarningMsg={this.state.cemWarningMsg}
                />
                {getLoadingScreen(this.state.loadState)}
                <div className={"mri-scene-container"}>
                    <MRIControlBar>
                        <div className={"mri-control-bar-left"}>
                            <ButtonGroup>
                                <MRIViewerButton
                                    toolTipText={"Scene Orientation"}
                                    name={"nav-cube"}
                                    imgBlue={cubeBlue}
                                    imgDark={cubeDark}
                                    imgLight={cubeLight}
                                    alt={"Nav Cube"}
                                >
                                    <NavCubeModal
                                        mriModel={this.mriModel}
                                        resetTick={() =>
                                            this.sliceControlRef.current.reset()
                                        }
                                        style={{ left: "524px" }}
                                    />
                                </MRIViewerButton>
                                <MRIViewerButton
                                    toolTipText={"Filter"}
                                    name={"filter"}
                                    imgBlue={filterBlue}
                                    imgDark={filterDark}
                                    imgLight={filterLight}
                                    alt={"Filter"}
                                >
                                    <FilterToggle
                                        mriModel={this.mriModel}
                                        patientAnatomyModel={
                                            this.patientAnatomyModel
                                        }
                                        displaySettings={{
                                            axesEnabled: true,
                                            mriEnabled: true,
                                            noMRIOption: true,
                                        }}
                                        autoLevel={this.state.autoLevel}
                                        setAutoLevel={(autoLevel) =>
                                            this.setState({ autoLevel })
                                        }
                                    />
                                </MRIViewerButton>
                            </ButtonGroup>
                            <SliceControl
                                ref={this.sliceControlRef}
                                mriModel={this.mriModel}
                                mriController={this.mriController}
                            />
                        </div>
                        <div className="mri-control-bar-right mr-10">
                            <ResetViewerButton
                                toolTipText={RESET_VIEW}
                                resetViewer={() =>
                                    resetViewer(
                                        this.meshRef,
                                        this.mriRef,
                                        this.sliceControlRef,
                                        this.mriModel
                                    )
                                }
                            />
                        </div>
                    </MRIControlBar>
                    <div className="mri-viewer">
                        <SplitPane
                            defaultSize={"60%"}
                            minSize={"0px"}
                            split={"vertical"}
                            pane1ClassName={"mri-pane"}
                            pane2ClassName={"mesh-pane"}
                            onDragFinished={() => {
                                this.mriRef.current.onWindowResize();
                                this.meshRef.current.onWindowResize();
                            }}
                        >
                            <MRIViewer
                                ref={this.mriRef}
                                mriModel={this.mriModel}
                                mriController={this.mriController}
                                patientAnatomyModel={this.patientAnatomyModel}
                            />
                            <MeshViewer
                                ref={this.meshRef}
                                staticViewer={true}
                                displaySettings={{
                                    mriEnabled: false,
                                    composerEnabled: true,
                                }}
                                mriModel={this.mriModel}
                                mriController={this.mriController}
                                patientAnatomyModel={this.patientAnatomyModel}
                                patientAnatomyController={
                                    this.patientAnatomyController
                                }
                                activateCoreClick={false}
                            />
                        </SplitPane>
                    </div>
                </div>
                {this.showDownloadCard()}
                {this.showChangeNotificationModal()}
                {this.getApprovePopup()}
            </div>
        );
    }
}

CreateTPlan_5Summary.propTypes = {
    useruuid: PropTypes.string,
    authToken: PropTypes.string,
    visituuid: PropTypes.string,
    patientuuid: PropTypes.string,
    planuuid: PropTypes.string,
    currentTreatmentPlan: PropTypes.object,
    displaySettings: PropTypes.object,
    setStepActive: PropTypes.func,
    setStepComplete: PropTypes.func,
    setCurrentTreatmentPlan: PropTypes.func,
    resetCreatePlanShard: PropTypes.func,
    resetCreatePlanBiopsyShard: PropTypes.func,
    resetImageViewerShard: PropTypes.func,
    setFlag: PropTypes.func,
    setDownloadProperties: PropTypes.func,
    downloadProperties: PropTypes.object,
};

CreateTPlan_5Summary.defaultProps = {
    useruuid: EMPTY_STRING,
    authToken: EMPTY_STRING,
    visituuid: EMPTY_STRING,
    patientuuid: EMPTY_STRING,
    planuuid: EMPTY_STRING,
    currentTreatmentPlan: {},
    displaySettings: {},
};

/* istanbul ignore next */
const mapStateToProps = function (state, ownProps) {
    let displaySettings = isEmpty(ownProps.displaySettings)
        ? state.ImageViewerReducer.displaySettings
        : ownProps.displaySettings;

    return {
        useruuid: state.LoginReducer.useruuid,
        authToken: state.LoginReducer.authToken,
        visituuid: state.CreatePlanReducer.visituuid,
        patientuuid: state.CreatePlanReducer.patientuuid,
        planuuid: state.CreatePlanReducer.planuuid,
        currentTreatmentPlan: state.CreatePlanReducer.currentTreatmentPlan,
        displaySettings: displaySettings,
        downloadProperties: state.HomeReducer.downloadProperties,
    };
};

/* istanbul ignore next */
const mapDispatchToProps = function (dispatch) {
    return {
        setFlag: (flag) => dispatch(setFlag(flag)),
        setCurrentTreatmentPlan: (plan) =>
            dispatch(setCurrentTreatmentPlan(plan)),
        setStepActive: (stepIdx, isActive) =>
            dispatch(setStepActive(stepIdx, isActive)),
        setStepComplete: (stepIdx, isComplete) =>
            dispatch(setStepComplete(stepIdx, isComplete)),
        resetCreatePlanShard: () => dispatch(resetCreatePlanShard()),
        resetCreatePlanBiopsyShard: () =>
            dispatch(resetCreatePlanBiopsyShard()),
        resetImageViewerShard: () => dispatch(resetImageViewerShard()),
        setDownloadProperties: (selectOpen, patID, planID, pdfOnly) =>
            dispatch(setDownloadProperties(selectOpen, patID, planID, pdfOnly)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateTPlan_5Summary);
